import { tKey } from "@/core/i18n";
import type { TFunction } from "i18next";

/**
 * Every user-facing string of batch auto-annotation, as `label` catalog keys
 * rendered with `t()`, matching PreAnnotateRunPanel/copy.ts. The sentences
 * that depend on the counts are functions of a `t`.
 */

type LabelT = TFunction<["label", "common"]>;

export const batchSkipNote = (
  t: LabelT,
  annotated: number,
  awaitingReview: number,
): string | null => {
  if (annotated > 0 && awaitingReview > 0)
    return t("label:batch.skip.both", { annotated, awaitingReview });
  if (annotated > 0) return t("label:batch.skip.annotated", { annotated });
  if (awaitingReview > 0) return t("label:batch.skip.awaitingReview", { awaitingReview });
  return null;
};

/** Progress card. */
export const batchRunningTitle = (t: LabelT, done: number, total: number): string =>
  t("label:batch.runningTitle", { current: Math.min(done + 1, total), total });

export const BATCH_RUNNING_BODY = tKey("label:batch.runningBody");

export const batchDoneTitle = (t: LabelT, done: number, failed: number): string =>
  failed === 0
    ? t("label:batch.doneTitle", { count: done })
    : t("label:batch.doneWithFailures", { done, failed });

export const BATCH_DONE_BODY = tKey("label:batch.doneBody");
export const BATCH_RETRY_FAILED = tKey("label:batch.retryFailed");
export const BATCH_DISMISS = tKey("label:actions.dismiss");
